import { getPhoneNumberDigits, getTrimmedPhoneNumber } from '../../lib/phone';

export const getSmsHref = (phoneNumber) => {
  const hasCountryCodePrefix =
    getTrimmedPhoneNumber(phoneNumber).startsWith('+');

  return `sms:${hasCountryCodePrefix ? '+' : ''}${getPhoneNumberDigits(phoneNumber)}`;
};
